import React, { useState } from "react";
import ProductSection from "../ProductsModule/Components/ProductSection";
import { Checkbox, Radio, TextField } from "@mui/material";
import { X } from "lucide-react";

const AddNewVoucher = () => {
  const [selectedValue, setSelectedValue] = useState("a");

  const handleChange = event => {
    setSelectedValue(event.target.value);
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const controlProps = item => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  return (
    <div className=" bg-white ml-[2.083333vw] mt-[1.5185vh] mr-[2.638888vw] overflow-y-scroll no-scrollbar">
      <div className="flex flex-row box-border h-[8.7vh] w-[100]">
        <div className="w-[60%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[3vh] font-medium font-outfit">
          Customer Name
        </div>
      </div>

      <div className="flex flex-col items-start justify-center box-border gap-y-1">
        <div className="grid grid-cols-3 gap-x-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="voucher name"
            variant="outlined"
            className="border-dotted border-2 border-green-400"
            required={true}
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Discount %"
            variant="outlined"
            required={true}
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="minimum order value (optional)"
            variant="outlined"
            size="small"
          />
        </div>

        <div className="grid grid-cols-3 gap-x-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="maximum order value (optional)"
            variant="outlined"
            size="small"
          />
        </div>

        <div className="grid grid-cols-3 gap-x-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="maximum order value (optional)"
            variant="outlined"
            size="small"
          />
        </div>

        <fieldset className="flex items-start justify-center flex-col w-[70%] pb-[6.186111vh] mx-[2.52222vw]  rounded-lg mt-[1.059259259vh] box-border border-dotted border-2 border-zinc-400">
          <legend className="ml-[0.3vw] text-[13px] font-outfit font-medium text-[#49454F]">
            Description (optional)*
          </legend>
          <p className="font-poppins text-[1.7vh] font-medium mt-[1.42%] text-[#79747E] text-start mx-6">
            Input
          </p>
        </fieldset>
      </div>

      <ProductSection data={"User"} />

      <div className="flex flex-row mt-[2vh] mx-[3.220338983%]">
        <TextField
          id="outlined-basic"
          label="Enter User"
          variant="outlined"
          size="small"
        />
        <p className=" flex flex-row items-center justify-center border-2 border-zinc-400 pl-2 mx-4 rounded-3xl text-[18px]">
          <span className="font-outfit font-light mx-2">Abcdef</span>{" "}
          <p className="p-2 rounded-full bg-[#E9E4E4]">
            <X color="#333333" />
          </p>
        </p>
      </div>

      <ProductSection data={"Discount Adjustment"} />

      <div className="flex flex-row   gap-x-3 w-[90%] mt-[1.959259259vh] box-border px-[3.220338983%]">
        <p className="font-medium font-outfit text-[16px]">
          <Radio color="secondary" {...controlProps("a")} /> on Bill
        </p>
        <p className="font-medium font-outfit text-[16px]">
          <Radio color="secondary" {...controlProps("b")} /> on Wallet
        </p>
      </div>

      <ProductSection data={"Validity"} />
      <div className="flex flex-row   gap-x-3 w-[90%] mt-[1.959259259vh] box-border px-[3.220338983%]">
        <TextField
          id="outlined-basic"
          label="From Date"
          variant="outlined"
          size="small"
        />
        <TextField
          id="outlined-basic"
          label="To Date"
          variant="outlined"
          size="small"
        />
      </div>
      <ProductSection data={"Brand"} />
      <div className="flex flex-col gap-x-3 w-[90%] mt-[1.959259259vh] box-border px-[3.220338983%]">
        <div className="flex flex-row items-center justify-start">
          <Checkbox defaultChecked {...label} color="default" />{" "}
          <p className="font-outfit font-medium">Add voucher for all brands</p>
        </div>
        <div className="flex flex-row mt-[2vh] ">
          <TextField
            id="outlined-basic"
            label="Brand"
            variant="outlined"
            size="small"
          />
          <p className=" flex flex-row items-center justify-center border-2 border-zinc-400 pl-2 mx-4 rounded-3xl text-[18px]">
            <span className="font-outfit font-light mx-2">Skechers</span>{" "}
            <p className="p-2 rounded-full bg-[#E9E4E4]">
              <X color="#333333" />
            </p>
          </p>
          <p className=" flex flex-row items-center justify-center border-2 border-zinc-400 pl-2 rounded-3xl text-[18px]">
            <span className="font-outfit font-light mx-2">Skechers</span>{" "}
            <p className="p-2 rounded-full bg-[#E9E4E4]">
              <X color="#333333" />
            </p>
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-x-3 w-[90%] mt-[1.959259259vh] box-border px-[3.220338983%]">
        <div className="flex flex-row items-center justify-start">
          <Checkbox defaultChecked {...label} color="default" />{" "}
          <p className="font-outfit font-medium">
            Apply for all articles for selected brands
          </p>
        </div>
        <div className="flex flex-row mt-[2vh]">
          <TextField
            id="outlined-basic"
            label="Article I'D"
            variant="outlined"
            size="small"
          />
          <p className=" flex flex-row items-center mx-4 justify-center border-2 border-zinc-400 pl-3 rounded-3xl text-[18px]">
            <span className="font-outfit font-light mx-2">5012</span>{" "}
            <p className="p-2 rounded-full bg-[#E9E4E4]">
              <X color="#333333" />
            </p>
          </p>
          <p className=" flex flex-row items-center justify-center border-2 border-zinc-400 pl-3 rounded-3xl text-[18px]">
            <span className="font-outfit font-light mx-2">5012</span>{" "}
            <p className="p-2 rounded-full bg-[#E9E4E4]">
              <X color="#333333" />
            </p>
          </p>
        </div>
      </div>
      <ProductSection data={"Poster"} />
      <div className="flex flex-col gap-x-3 w-[90%] mt-[1.959259259vh] box-border px-[3.220338983%]">
        <div className="flex flex-row items-center justify-start">
          <Checkbox defaultChecked {...label} color="default" />{" "}
          <p className="font-outfit font-medium">Show Poster for Voucher</p>
        </div>

        <div className="flex items-start justify-start flex-col">
          <fieldset className="flex items-center justify-center flex-col w-[10.708333vw] pb-[6.186111vh] mt-[1.059259259vh] box-border border-dotted border-2 rounded-md border-[#79747E]">
            <legend className="ml-[0.388vw] text-[2.0037037vh] font-outfit font-medium text-[#49454F]">
              Image
            </legend>
            <img
              src={require("../../../assets/upload.png")}
              alt="upload here"
              className="pt-[3.9814814vh]"
            />
            <p className="font-poppins text-[14px] font-medium mt-[1.42%] text-[#79747E]">
              Browse Upload
            </p>
          </fieldset>
          <p className="flex items-center justify-center text-[2.0037037vh] font-outfit font-normal mt-2">
            *Preffered ratio- 1:2
          </p>
        </div>
      </div>

      <div className="flex flex-row mt-9 items-start justify-start mx-[2vw] gap-x-3 pb-5">
        <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.23755vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
          {" "}
          <span className="px- text-[#5652B0] px-3">Cancel</span>
        </button>
        <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.23755vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
          {" "}
          <span className="px-2 text-white ">Save</span>
        </button>
      </div>
    </div>
  );
};

export default AddNewVoucher;
